module.exports = __webpack_public_path__ + "images/farm-marker_eb18840.png";